import { PropsWithChildren, useState } from 'react'

import { Attendee, Meeting } from '@reception-web/common/api/www'

import { Information, MeetingContext } from './MeetingContext'

export function MeetingProvider({ children }: PropsWithChildren) {
  const [meeting, setMeeting] = useState<Meeting | null>(null)
  const [attendee, setAttendee] = useState<Attendee | null>(null)
  const [information, setInformation] = useState<Information | null>(null)
  const [isRedial, setIsRedial] = useState(false)

  return (
    <MeetingContext.Provider
      value={{
        meeting,
        setMeeting,
        attendee,
        setAttendee,
        information,
        setInformation,
        isRedial,
        setIsRedial,
      }}
    >
      {children}
    </MeetingContext.Provider>
  )
}
